module.exports = __webpack_public_path__ + "img/system7-mini.064d2ede.png";